// src/components/HeroSection.jsx
// 3-column layout: Text | Images | Carousel
// Left edge aligns with chat box
import React from 'react';
import PopularFlightsCarousel from './PopularFlightsCarousel';
import './HeroSection.css';

const HeroSection = ({ userLocation, onFlightSelect }) => {
  return (
    <div className="hero-row">
      {/* LEFT: Text */}
      <div className="hero-text-side">
        <h1 className="hero-heading">Book your trip the smart way</h1>
        <p className="hero-subtext">Skip the endless searching. Just tell our <b>AI where you want to go</b>, and we'll find the perfect flight with price predictions and jet lag tips—all in one conversation.</p>
      </div>
      
      {/* MIDDLE: 2x2 Images */}
      <div className="hero-images-side">
        <div className="hero-images-grid">
          <div className="hero-img">
            <img src="https://images.unsplash.com/photo-1436491865332-7a61a109cc05?w=150&h=100&fit=crop" alt="Travel" />
          </div>
          <div className="hero-img">
            <img src="https://images.unsplash.com/photo-1469854523086-cc02fe5d8800?w=150&h=100&fit=crop" alt="Travel" />
          </div>
          <div className="hero-img">
            <img src="https://images.unsplash.com/photo-1551882547-ff40c63fe5fa?w=150&h=100&fit=crop" alt="Travel" />
          </div>
          <div className="hero-img">
            <img src="https://images.unsplash.com/photo-1506905925346-21bda4d32df4?w=150&h=100&fit=crop" alt="Travel" />
          </div>
        </div>
      </div>
      
      {/* RIGHT: Carousel */}
      <div className="hero-carousel-side">
        <PopularFlightsCarousel 
          userLocation={userLocation}
          onFlightSelect={onFlightSelect}
        />
      </div>
    </div>
  );
};

export default HeroSection;
